import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { cartographyApi } from 'src/Services/API';
import { ApiError } from 'src/types/api-error.types';
import { CartographyTreeDto } from 'src/types/cartography.types';

const useFetchCartographyTree = () => {
  const assetId = useCurrentAssetId();

  return useQuery<CartographyTreeDto, AxiosError<ApiError>>({
    queryKey: ['fetch-cartography-tree', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return cartographyApi.getTree(assetId);
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchCartographyTree;
